import React from 'react';
import useAppLocale from '~/data/hooks/useAppLocale';
import { openChat } from '~/utils/respondWidget';
import BrokenLinkLayout from './layout';

export default function BrokenLink(): JSX.Element {
  const { locale, onChangeLocale } = useAppLocale();

  const openContactSupport = () => {
    // web only; openChat() is a no-op when the loader has not booted yet
    openChat();
  };

  return (
    <BrokenLinkLayout
      selectedLocale={locale}
      onSelectedLocale={onChangeLocale}
      openContactSupport={openContactSupport}
    />
  );
}
